/* Source: /app/lib/utils.cl.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
function cn(input) {
  let inputs = [].slice.call(arguments);
  return twMerge(clsx(inputs));
}
export {cn};